export default "__VITE_ASSET__8244966d__"